// src/data/galleryImages.js

const galleryImages = [
  {
    id: 1,
    src: require("../assets/gallery/picture (1).jpeg"),
    alt: "Picture 1",
  },
  {
    id: 2,
    src: "/assets/gallery/picture (2).jpeg",
    alt: "Picture 2",
  },
  {
    id: 3,
    src: "/assets/gallery/picture (3).jpeg",
    alt: "Picture 3",
  },
  {
    id: 4,
    src: "/assets/gallery/picture (4).jpeg",
    alt: "Picture 4",
  },
  {
    id: 5,
    src: "/assets/gallery/picture (5).jpeg",
    alt: "Picture 5",
  },
  // Add more if needed
];

export default galleryImages;
